import React from 'react';
import moment from 'moment';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data, onDelete, onEdit}) => {
    return (
        <PPMobileCardView
            title={moment(data.date).format("DD-MM-YYYY")}
            id={data.id}
            rows={[
                { label: 'Transaction Type', value: data.transactionTypeName },
                { label: 'Bank', value: data.bankName },
                { label: 'Amount (Rs.)', value: data.amount },
            ]}
            menuItems={[
                { label: 'Edit', onClick: onEdit },
                { label: 'Delete', onClick: onDelete },
            ]}
        />
    )
};

export default Mobile;